import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import axiosInstance from '../services/AxiosInstance';

const Dropdown = ({
    url = null,
    value = [],
    title = "",
    type = "dropdown",
    className = "",
    required = false,
    onChange,
    filters = "",
    options,
    placeholder = "Select...",
    ...props
}) => {
    const [datas, setDatas] = useState([]);
    let cancelToken;

    useEffect(() => {
        if (options) setDatas(options);
        else getDatas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url, filters]);

    const getDatas = async () => {
        if (url) {
            await axiosInstance(`${url}?${filters}&fields=id,name`, { method: "GET" })
                .then(res => {
                    setDatas(res?.data?.results)
                })
                .catch(err => console.log('err : ', err))
        }
        return datas
    }


    const handleSearchChange = async e => {
        // Function to cancel previous request on searching for api optimization
        if (typeof cancelToken != typeof undefined) {
            cancelToken.cancel("Operation canceled due to new request.")
        }
        cancelToken = axios.CancelToken.source()
        try {
            await axiosInstance(
                `${url}?${filters}&fields=id,name&search=${e}`,
                {
                    method: "GET",
                    cancelToken: cancelToken.token
                }).then(res => {
                    setDatas(res?.data?.results)
                })
        } finally {
            return datas
        }
    }

    const handleSearch = (e) => {
        // Seperate function since react select onInputChange doesn't accept async
        handleSearchChange(e);
    }

    return (
        <>
            {
                title && <label htmlFor="name" className="mb-0">
                    <strong>{title}</strong>
                    {required === true && <span style={{ color: 'red' }} > * </span>}
                </label>
            }
            {
                type !== "dropdown" ?
                    <Select
                        isMulti
                        options={datas}
                        value={value}
                        closeMenuOnSelect={false}
                        name={props.name}
                        placeholder={placeholder}
                        className='basic-multi-select'
                        classNamePrefix="select"
                        getOptionLabel={(menu) => menu['name']}
                        getOptionValue={(menu) => menu['id']}
                        onChange={e => onChange(e, props.name, 'dropdown')}
                        onInputChange={handleSearch}
                    />
                    :
                    <Select
                        isClearable
                        getOptionLabel={(menu) => menu['name']}
                        getOptionValue={(menu) => menu['id']}
                        onChange={e => onChange(e, props.name, 'dropdown')}
                        onInputChange={handleSearch}
                        options={datas}
                        value={value}
                        maxMenuHeight={150}
                        {...props}
                    />
            }

        </>
    );
}

export default Dropdown;